module.exports = "bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvZm9udHMvaGFuZGxlZS1yZWd1bGFyLjY0YmNmZTEudHRmIjs="


//////////////////
// WEBPACK FOOTER
// ./node_modules/base64-loader!./node_modules/scratch-render-fonts/src/handlee-regular.ttf
// module id = Mg17
// module chunks = 0